import type { Artist, DesignType, TattooStyle } from '@/domain/types';

// The customer's preferred style is a TattooStyle; an artist's speciality is a
// DesignType[]. The two vocabularies only partly overlap, so we map each style
// to the design types that count as a match for "Best fit".
export const STYLE_TO_DESIGN_TYPES: Record<TattooStyle, DesignType[]> = {
  'fine-line': ['fine-line'],
  blackwork: ['blackwork'],
  colour: ['colour-realism'],
  realism: ['colour-realism', 'black-and-grey'],
  script: ['lettering'],
  traditional: ['traditional', 'flash'],
  'neo-traditional': ['neo-traditional'],
  geometric: ['blackwork', 'fine-line'],
};

/** True when an artist's speciality set covers the customer's preferred style. */
export function artistMatchesStyle(artist: Artist, style: TattooStyle): boolean {
  const wanted = STYLE_TO_DESIGN_TYPES[style];
  return artist.styleSpeciality.some((s) => wanted.includes(s));
}
